import { render, staticRenderFns } from "./Artesania.vue?vue&type=template&id=429ab3d6"
import script from "./Artesania.vue?vue&type=script&lang=js"
export * from "./Artesania.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports